// /developers/docs: the public API reference (the same one as the app's API → Docs tab), for search engines and for
// developers deciding before they sign up.
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';
import Seo, { ORGANIZATION, SITE_URL } from '../site/Seo';
import ApiReference from '../../myApi/ApiReference';
import { PUBLIC_BASE_URL } from '../../myApi/apiDocsContent';
import './developers.css';

export default function DevelopersDocsPage() {
  const { currentUser } = useContext(AuthContext);
  const keysLink = currentUser ? { to: '/api', label: 'Manage your keys' } : { to: '/signup', label: 'Get an API key' };

  return (
    <>
      <Seo
        title="Bumpups API reference: endpoints, errors and limits"
        description="Reference for the Bumpups API: process YouTube videos into chapters, ask questions about them, and check your minutes. Request and response examples in curl, Python and JavaScript."
        jsonLd={[{
          '@type': 'TechArticle',
          headline: 'Bumpups API reference',
          url: `${SITE_URL}/developers/docs`,
          publisher: ORGANIZATION,
        }]}
      />
      <section className="dev-docs">
        <div className="mk-container">
          <p className="dev-docs-crumbs"><Link to="/developers">Bumpups API</Link> / Reference</p>
          <h1 className="mk-h2 dev-docs-title">API reference</h1>
          <ApiReference baseUrl={PUBLIC_BASE_URL} keysLink={keysLink} />
        </div>
      </section>
    </>
  );
}
